import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

// Import Images
// import logolight from "../../../assets/images/logo-light.png";

const FooterPage = () => {
  return (
    <React.Fragment>
      <footer className="custom-footer bg-dark py-5 position-relative">
        <Container>
          <Row>
            <Col lg={4} className="mt-4">
              <div>
                <div>
                  {/* <img src={logolight} alt="logo light" height="17" /> */}
                </div>
                <div className="mt-4 fs-13">
                  <p className="fs-4">QR Menu</p>
                  <p className="ff-secondary">
                    QR Menu Builder is an easy, quick, and free solution to
                    building a fast-loading digital QR menu yourself or with the
                    help of our experts!
                  </p>
                  <p className="mb-0 ff-secondary">Suryabinayak, Bhaktapur</p>
                  <p className="mb-0 ff-secondary">Mobile: +977 984-3723855</p>
                  <p className="mb-0 ff-secondary">Email: <a href="mailto:info@qrmenu.asia"> info@qrmenu.asia</a></p>
                  <p className="mb-0 ff-secondary">Website: <a href="https://qrmenu.sebs.asia/" className="text-white text-decoration-underline">qrmenu.sebs.asia</a></p>
                </div>
              </div>
            </Col>

            <Col lg={7} className="ms-lg-auto">
              <Row>
                <Col sm={6} className="mt-4">
                  <h5 className="text-white text-start mb-0">Company</h5>
                  <div className="text-muted mt-3">
                    <ul className="list-unstyled ff-secondary footer-list fs-14">
                      <li>
                        <Link to="https://sebs.asia/">About Us</Link>
                      </li>
                      <li>
                        <Link to="https://sebs.asia/">Gallery</Link>
                      </li>
                      <li>
                        <Link to="https://sebs.asia/">Projects</Link>
                      </li>
                      <li>
                        <Link to="https://sebs.asia/">Timeline</Link>
                      </li>
                    </ul>
                  </div>
                </Col>
                {/* <Col sm={4} className="mt-4">
                  <h5 className="text-white text-start  mb-0">Apps Pages</h5>
                  <div className="text-muted mt-3">
                    <ul className="list-unstyled ff-secondary footer-list fs-14">
                      <li>
                        <Link to="/pages-pricing">Calendar</Link>
                      </li>
                      <li>
                        <Link to="/apps-mailbox">Mailbox</Link>
                      </li>
                      <li>
                        <Link to="/apps-chat">Chat</Link>
                      </li>
                      <li>
                        <Link to="/apps-crm-deals">Deals</Link>
                      </li>
                      <li>
                        <Link to="#">Kanban Board</Link>
                      </li>
                    </ul>
                  </div>
                </Col> */}
                <Col sm={4} className="mt-4">
                  <h5 className="text-white text-start  mb-0">Support</h5>
                  <div className="text-muted mt-3">
                    <ul className="list-unstyled ff-secondary footer-list fs-14">
                      <li>
                        <Link to="https://sebs.asia/">FAQ</Link>
                      </li>
                      <li>
                        <Link to="https://sebs.asia/">Contact</Link>
                      </li>
                      <li>
                        <Link to="organization-sitemap">Sitemap</Link>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="text-center text-sm-start align-items-center mt-5">
            <Col sm={6}>
              <div>
                <p className="copy-rights mb-0">
                  {new Date().getFullYear()} © Sebs - Search Eyes Business Solutions
                </p>
              </div>
            </Col>
            <Col sm={6}>
              <div className="text-sm-end mt-3 mt-sm-0">
                <ul className="list-inline mb-0 footer-social-link">
                  <li className="list-inline-item">
                    <Link to="#" className="avatar-xs d-block">
                      <div className="avatar-title rounded-circle">
                        <i className="ri-facebook-fill"></i>
                      </div>
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link to="#" className="avatar-xs d-block">
                      <div className="avatar-title rounded-circle">
                        <i className="ri-github-fill"></i>
                      </div>
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link to="#" className="avatar-xs d-block">
                      <div className="avatar-title rounded-circle">
                        <i className="ri-linkedin-fill"></i>
                      </div>
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link to="#" className="avatar-xs d-block">
                      <div className="avatar-title rounded-circle">
                        <i className="ri-google-fill"></i>
                      </div>
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link to="#" className="avatar-xs d-block">
                      <div className="avatar-title rounded-circle">
                        <i className="ri-dribbble-line"></i>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default FooterPage;
